export default __webpack_public_path__ + "static/media/nav-calendar-white.8509b1e6.svg";